import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'react-materialize';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../../functions/logging';

import { calculatePoints } from '../../functions/rewards';
import { formatDuration } from '../../functions/time';
import { getSubscribedGroups } from '../../api/groups';
import { getUserMonitor, updateUserMonitor } from '../../api/user';

import '../../static/home/Rewards.css';
import localeMessages from '../../locales/rewards';

import * as auth from '../../functions/auth';
import * as studyFns from '../../functions/study';
// import * as helpers from '../../functions/helpers';

// import PageLoader from '../global/PageLoader';
import FadeIn from '../global/FadeIn';

import { setUserMonitor, setPilotlyPoints } from '../../redux/actions/index';

import ribbonIcon from '../../assets/home/rewards.png';

class Rewards extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {},
			arePointsUpdated: false
		};

		this.getUserMonitor = this.getUserMonitor.bind(this);
		this.updateUserMonitor = this.updateUserMonitor.bind(this);
	}

	componentDidMount() {
		let user_token = auth.getToken();
		if (this.props.currentUser && user_token) {
			this.loadSubscribedGroups(user_token, this.props.currentUser);
			this.getUserMonitor(this.props.currentUser.user_id, user_token);
		}
	}

	componentDidUpdate() {
		let containsErrorsPresent = Object.keys(this.state.errors).length;
		let user_token = auth.getToken();
		if (this.props.activityList && !this.state.arePointsUpdated && !containsErrorsPresent && user_token && this.props.currentUser) {
			this.updateUserPoints(this.props.userMonitor, this.props.activityList, this.props.currentUser.user_id, user_token);
		}
	}

	async loadSubscribedGroups(user_token, currentUser) {
		Logger.log(this.constructor.name, "loadSubscribedGroups(): USER TOKEN: " + user_token);

		try {
			const results = await getSubscribedGroups(user_token);
			if (results) {
				Logger.log(this.constructor.name, "Get Groups Successful", results);
				this.setState({ errors: {} });
				this.setupMyList(results);
			}
			else {
				Logger.log(this.constructor.name, "Get Groups Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_loading_studies);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "Get Groups Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_loading_studies);
			this.setState({ errors: errors });
		}
	}

	async getUserMonitor(user_id, user_token) {
		Logger.log(this.constructor.name, "getUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);
		this.setState({ overviewLoading: true });

		try {
			const results = await getUserMonitor(user_id, user_token);
			if(results) {
				Logger.log(this.constructor.name, "GET User Monitor Successful", results);
				this.setState({overviewLoading: false, errors: {} }, () => {
					this.props.setUserMonitor(results);
				});
			}
			else {
				Logger.log(this.constructor.name, "GET User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_loading_user);
				this.setState({ errors: errors, overviewLoading: false });

			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "GET User Monitor Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_loading_user);
			this.setState({ errors: errors, overviewLoading: false});
		}
	}

	async updateUserMonitor(user_id, user_token, points, last_view) {
		Logger.log(this.constructor.name, "updateUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const result = await updateUserMonitor(user_id, user_token, points, last_view);
			if (result) {
				Logger.log(this.constructor.name, "UPDATE User Monitor Successful", result);
				this.setState({ errors: {}, arePointsUpdated: true });
				this.props.setUserMonitor(result);
			}
			else {
				Logger.log(this.constructor.name, "UPDATE User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_updating_user);
				this.setState({ errors: errors, arePointsUpdated: true });

			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "UPDATE User Monitor Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = this.props.intl.formatMessage(localeMessages.rewards_error_updating_user);
			this.setState({ errors: errors, arePointsUpdated: true });
		}
	}

	setupMyList(userStudies) {
		let myList = [];
		let pilotlyPointsTotal = 0;

		if (userStudies && userStudies.length) {
			userStudies.forEach(study => {
				if (!studyFns.isUserScreened(study, this.props.currentUser)) {
					pilotlyPointsTotal += study.userData.complete ? calculatePoints(study) : 0;
					myList.push(study);
				}
			});
		}
		this.props.setPilotlyPoints(pilotlyPointsTotal);
		this.props.setMyList(myList);
	}

	updateUserPoints(userMonitor, activityList, user_id, user_token) {
		if(userMonitor && activityList && activityList.length) {
			let userPointTotal = 0;
			let userMonitorLastUpdate = userMonitor.updated_at ? moment(userMonitor.updated_at) : null;
			activityList.forEach((group) => {
				let groupStartDate = moment(group.start_date);
				if (group.userData && group.userData.complete && (!userMonitorLastUpdate || userMonitorLastUpdate.isSameOrAfter(groupStartDate))) {
					userPointTotal += calculatePoints(group);
				}
			});
			this.updateUserMonitor(user_id, user_token, userPointTotal, "rewards_view");
		} 
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		return (
			<FadeIn>
				<div className="pilotly-home-rewards">
					<RewardsOverview {...this.props} userPilotlyPoints={this.props.userPilotlyPoints} />
					<RewardsList {...this.props} groupsReady={true}/>
					<RewardsFooter {...this.props} userPilotlyPoints={this.props.userPilotlyPoints} />
				</div>
			</FadeIn>
		);
	}
}

export class RewardsOverview extends Component {

	renderPointsMessage(userPilotlyPoints) {
		let points_per_study = this.props.intl.formatMessage(localeMessages.points_per_study);

		// let pointsSpan = <strong>points_per_study</strong>;
		// let firstLine = this.props.intl.formatMessage(localeMessages.earn_points, { points_per_study: pointsSpan });

		let firstLine = (
			<FormattedMessage
				id="rewards.earn_points"
				defaultMessage={`Earn {points_per_study} you complete`}
				values={{ points_per_study: <strong>{points_per_study}</strong> }}
			/>
		);

		let secondLine = null;

		if (!userPilotlyPoints) {
			secondLine = (
				<FormattedMessage
					id="rewards.points_for_reward"
					defaultMessage={`Each {pp} can be redeemed for a {prize}`}
					values={{ pp: <strong>60 points</strong>, prize: <strong>$5 gift card</strong> }}
				/>
			);
		}

		if (userPilotlyPoints && userPilotlyPoints < 60) {
			let pointDiff = 60 - userPilotlyPoints;
			
			secondLine = (
				<FormattedMessage
					id="rewards.need_more_points_for_rewards"
					defaultMessage={`Once you earn another {pp} you will be able to redeem your points for rewards`}
					values={{ pp: <strong>{pointDiff}pp</strong> }}
				/>
			);
		}

		if (userPilotlyPoints && userPilotlyPoints >= 60) {
			firstLine = (
				<FormattedMessage
					id="rewards.continue_earn_points"
					defaultMessage={`Continue earning {points_per_study} you complete`}
					values={{ points_per_study: <strong>{points_per_study}</strong> }}
				/>
			);
			
			secondLine = (
				<FormattedMessage
					id="rewards.earned_points_for_rewards"
					defaultMessage={`Congrats! You have earned enough {pp} to redeem for rewards`}
					values={{ pp: <strong>pp</strong> }}
				/>
			);
		}

		return (
			<div className="pilotly-earn-points-message">
				{firstLine}<br /> 
				{secondLine}
			</div>
		);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		let userPilotlyPoints = this.props.userPilotlyPoints;
		let pointsMessageDisplay = this.renderPointsMessage(userPilotlyPoints);
		return (
			<FadeIn>
				<div className="pilotly-rewards-box pilotly-rewards-overview">			
					<div className="pilotly-rewards-overview-summary">
						<div className={"pilotly-rewards-points" + (userPilotlyPoints > 99 ? " width-35p" : userPilotlyPoints > 9 ? " width-30p" : "")}>
							<span className="pilotly-points-count pilotly-rewards-points-count vertical-align-none">
								{this.props.overviewLoading ? "--" : userPilotlyPoints}
							</span>
							<span className="pilotly-points-suffix pilotly-rewards-points-suffix vertical-align-none">
								pp
							</span>
						</div>
						<div className="pilotly-rewards-ribbon">
							<img className='pilotly-rewards-ribbon-image' src={ribbonIcon} alt='Profile' />
						</div>
						<div className={"pilotly-rewards-cta" + (userPilotlyPoints > 99 ? " three-digit-cta-space" : userPilotlyPoints > 9 ? " two-digit-cta-space" : "")}>
							<FormattedMessage
								id="rewards.complete_study_for_points"
								defaultMessage={`Complete a study to earn points towards rewards`}
							/>
						</div>
					</div>
					{ pointsMessageDisplay }
				</div>
			</FadeIn>
		);
	}
}

export class RewardsList extends Component {

	renderRewardList(activityList, groupsReady) {
		if (activityList && activityList.length) {
			let groupList = [];
			activityList.forEach((group) => {
				let groupDuration = formatDuration(group.content.duration);
				let groupPoints = calculatePoints(group);
				let groupDisplay = (
					<div key={group._id} className="pilotly-rewards-list-item mb-15">
						<div className="list-item points pull-left">
							{ groupPoints }<span>pp</span>
						</div>
						<div className="list-item duration pull-right">
							{ groupDuration } &nbsp;
							<FormattedMessage
								id="rewards.study"
								defaultMessage={`Study`}
							/>
						</div>
						<div className="list-item title">
							{ group.study_name || group.title}
						</div>
					</div>
				);
				if (group.userData && group.userData.complete) groupList.push(groupDisplay);
			});
			if (groupList.length) return groupList;
			else return (
				<p className="text-align-center">
					<FormattedMessage
						id="rewards.complete_study_earn_rewards"
						defaultMessage={`Complete studies to earn rewards!`}
					/>
				</p>
			);
			
		}
		else if (activityList && !activityList.length) {
			return (
				<p className="text-align-center">
					<FormattedMessage
						id="rewards.subscribe_and_complete_study_earn_rewards"
						defaultMessage={`Subscribe and Complete studies to earn rewards!`}
					/>
				</p>
			);
		}
		return "";
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		let rewardListDisplay = this.renderRewardList(this.props.activityList);

		return (
			<div className="pilotly-rewards-list">
				{/* <PageLoader addedClass="pilotly-blue-background" loading={!this.props.groupsReady} small={true} /> */}
				{rewardListDisplay}
			</div>
		);
	}
}

class RewardsFooter extends Component {
	render() {
		return(
			<div className="pilotly-home-footer">
				<Button disabled={this.props.userPilotlyPoints < 60}>
					<FormattedMessage
						id="rewards.button.redeem_points"
						defaultMessage={`Redeem Points`}
					/>
				</Button>
			</div>
		);
	}
}

/*
class Reward extends Component {
	render() {
		Logger.log(this.constructor.name, this.props, this.state);
		return (
			<div className="pilotly-rewards-box pilotly-rewards-reward">
				Reward
			</div>
		);
	}
}

*/
function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		userMonitor: state.currentUser.userMonitor,
		userPilotlyPoints: state.currentUser.userPilotlyPoints,
	};
}
	
function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setPilotlyPoints,
		setUserMonitor
	}, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Rewards));



// WEBPACK FOOTER //
// ./src/components/home/Rewards.js